<template>
  <div class="card-text card-front-text">
    <br />
    <p>Question</p>

    <img
      class="banner-quizz"
      :src="'../img/data/' + response.defaultImagePlant"
      v-if="game === 2"
    />
    <h2 v-if="game === 1">{{ plant.nom }}</h2>
    <toxicity @getToxicity="selectToxicity" />
    <div class="spacer" />
    <responses :goodResponse="this.plant" @getResponse="selectResponse" />
    <button @click="submit">Valider</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import responses from "./responses.vue";
import toxicity from "./toxicity.vue";
export default {
  name: "question",
  components: { toxicity, responses },
  props: {
    plant: Object,
  },
  data() {
    return {
      response: {
        defaultImagePlant: this.plant.image[
          this.getRandomInt(this.plant.image.length)
        ],
        toxicity: null,
        plant: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      game: "game",
    }),
  },
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    selectToxicity(toxicity) {
      this.response.toxicity = toxicity;
    },
    selectResponse(response) {
      this.response.plant = response;
    },
    submit() {
      if (this.response.toxicity === null || this.response.plant === null)
        return;
      this.$emit("submitQuestion", this.response);
    },
  },
};
</script>

<style></style>
